import { Box, Grid } from "@mui/material";
import { FC } from "react";
import Header from "../common/header/Header";
import SideMenu from "../sidemenu/SideMenu";
import Footer from "../common/footer/Footer";
import Constants from "../../utils/Constants";

type Props = {
  selectBtnIndex: number;
  width?: string; // SideMenuのwidth属性の値
};


const CommonPage: FC<Props> = ({ children, selectBtnIndex, width = "200px" }) => {
  return (
    <>
      <Header />
      <Box sx={{ pt: 8 }}>
        <SideMenu selectBtnIndex={selectBtnIndex} width={width} />
        <Box display={"grid"} sx={{ gridTemplateRows: `1fr auto`, minHeight: `calc(100vh - ${Constants.HEADER_HEIGHT})`}}>
          <Box component="main" sx={{ width: `calc(100% - ${width})`, ml: 25 }}>
            {children}
          </Box>
          <Box>
            <Footer sx={{ width: `calc(100% - ${width})`, ml: 25 }}/>
          </Box>
        </Box>
      </Box>
    </>
  );
};

export default CommonPage;

// const CommonPage: FC<Props> = ({ children, selectBtnIndex, width = "200px" }) => {
//   return (
//     <>
//       <Header />
//       <Box sx={{ pt: 8 }}>
//         <SideMenu selectBtnIndex={selectBtnIndex} width={width} />
//         <Box sx={{ alignContent: "space-between"}}>
//         <Box component="main" sx={{ width: `calc(100% - ${width})`, ml: 25, flexGrow: 1 }}>
//           {children}
//         </Box>
//         <Box>
//           <Footer sx={{ width: `calc(100% - ${width})`, ml: 25 }}/>
//         </Box>
//         </Box>
        
//         {/* <Footer sx={{ width: `calc(100% - ${width})`, ml: 25 }}/> */}
//       </Box>
//     </>
//   );
// };

// export default CommonPage;
